import Typography from '@mui/material/Typography'
import { Form, Formik } from 'formik'
import { useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import * as Yup from 'yup'
import { MoovyButton, MoovyForm } from '../../../components'
import useUserEmail from '../../../hooks/useUserEmail'

const InvoiceForm = (props: {
  onSubmit: (userEmail: string) => void
  isButtonDisabled: boolean
}) => {
  const [userEmail, setUserEmail] = useUserEmail()
  const [inputValue, setInputValue] = useState(userEmail)
  const intl = useIntl()

  const validationSchema = Yup.object({
    email: Yup.string()
      .email(
        intl.formatMessage({
          id: 'page.webPayment.stepInvoice.form.email.errors.email',
        }),
      )
      .required(
        intl.formatMessage({
          id: 'page.webPayment.stepInvoice.form.email.errors.required',
        }),
      ),
  })
  return (
    <Formik
      initialValues={{
        email: userEmail,
      }}
      onSubmit={(values, { setSubmitting }) => {
        setUserEmail(inputValue)
        props.onSubmit(values.email)
      }}
      validationSchema={validationSchema}
    >
      {({ values, errors, handleChange, handleSubmit }) => (
        <Form
          onSubmit={handleSubmit}
          style={{
            width: '100%',
            padding: '0 1rem',
          }}
        >
          <MoovyForm.FormContainer>
            <MoovyForm.FormTextField
              name="email"
              label={intl.formatMessage({
                id: 'page.webPayment.stepInvoice.emailAddress',
              })}
              value={values.email}
              error={!!errors.email}
              errorText={errors.email}
              onChange={(event) => {
                setInputValue(event.target.value)
                handleChange(event)
              }}
            />
            <Typography align="left" variant="body2">
              <FormattedMessage id="page.webPayment.stepInvoice.contactInformation.description" />
            </Typography>
            <MoovyButton
              disabled={props.isButtonDisabled}
              type="submit"
              aria-label={intl.formatMessage({
                id: 'page.webPayment.stepInvoice.button.payParking',
              })}
              fullWidth
              color="secondary"
            >
              <FormattedMessage
                id={`page.webPayment.stepInvoice.button.payParking${
                  props.isButtonDisabled ? '.loading' : ''
                }`}
              />
            </MoovyButton>
          </MoovyForm.FormContainer>
        </Form>
      )}
    </Formik>
  )
}

export default InvoiceForm
